export default __webpack_public_path__ + "static/media/walterScott.9c4fd05b.png";